import { useContext } from 'react';
import { Button, ButtonGroup, Heading, Modal, Paragraph, TextButton } from '@zillow/constellation-10';
import useModal from '../../../hooks/useModal';
import { AppContext } from '../../../contexts/AppContextProvider';

type ContactInfoCallModalProps = {
  name?: string;
  phone: string;
  onCallCancelClick?: () => void;
  onClose?: () => void;
};

export default function ContactInfoCallModal({
  name = '',
  phone,
  onCallCancelClick,
  onClose,
}: ContactInfoCallModalProps): JSX.Element {
  const { isMobileDevice } = useContext(AppContext);
  const { clearModal } = useModal();
  const handleModalClose = () => {
    if (onClose) {
      onClose();
    }
    clearModal();
  };

  const handleCallClick = () => {
    window.location.href = `tel:${phone}`;
  };

  const handleCancelClick = () => {
    if (onCallCancelClick) {
      onCallCancelClick();
    } else {
      handleModalClose();
    }
  };

  return (
    <Modal
      dividers={false}
      closeButton={<span hidden />}
      open={true}
      onOpenChange={(isOpen) => !isOpen && handleCancelClick()}
      size="xs"
      body={
        <>
          <Heading level={5} css={{ textAlign: 'center', marginBottom: 'tight' }}>
            {name}
          </Heading>
          <Paragraph css={{ textAlign: 'center' }}>{phone}</Paragraph>
        </>
      }
      footer={
        <ButtonGroup aria-label="Modal actions" fluid orientation="vertical" css={{ width: '100%', gap: 'md' }}>
          {isMobileDevice ? (
            <>
              <TextButton tone="brand" onClick={handleCancelClick}>
                Cancel
              </TextButton>

              <Button tone="brand" emphasis="filled" onClick={handleCallClick}>
                Call
              </Button>
            </>
          ) : (
            <Button tone="brand" emphasis="filled" onClick={handleCancelClick}>
              Close
            </Button>
          )}
        </ButtonGroup>
      }
    />
  );
}
